import React from 'react';
import { Router, Switch } from 'react-router-dom';
import ConfigProvider from 'antd/lib/config-provider';
import ruRU from 'antd/lib/locale-provider/ru_RU';
import { createBrowserHistory } from 'history';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { ChatProvider } from '@devdept/samolet-ui/lib/context/chat';
import { TendUI } from '@10d/tend-ui/theme';
import { Dialog } from 'components/Dialog';
import { ROUTE_PROMO } from 'constants/routes';
import Promo from 'pages/Promo';
import { queryClient } from 'api/queryClient';
import SentryRoute from 'components/SentryRoute';
import withErrorBoundary from 'hocs/withErrorBoundary';
import Root from 'Root';
import store from 'store';
import DIProvider from 'core/di/Container';
import { AuthProvider } from 'context/Auth';
import { getStandFromEnv } from 'utils/stand';

const history = createBrowserHistory();

TendUI.init();

const App: React.FC = () => (
  <Provider store={store}>
    <AuthProvider>
      <TendUI>
        <Dialog.Styles />

        <Router history={history}>
          <ConfigProvider locale={ruRU}>
            <Switch>
              <SentryRoute path={ROUTE_PROMO} component={Promo} />

              <ChatProvider stand={getStandFromEnv()}>
                <DIProvider>
                  <Root />
                </DIProvider>
              </ChatProvider>
            </Switch>
          </ConfigProvider>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </TendUI>
    </AuthProvider>
  </Provider>
);

const AppWithErrorBoundary = withErrorBoundary(App);

const AppWithQueryProvider = () => (
  <QueryClientProvider client={queryClient}>
    <AppWithErrorBoundary />
  </QueryClientProvider>
);

export default AppWithQueryProvider;
